<template>
	<div id="app">
		<div class="row">
			<main class="col">
				<div class="cw-content-nosidenav">
					<div class="mt-4 mb-4 navigation">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item"><a href="/">{{ $t('home') }}</a></li>
								<li class="breadcrumb-item"><a href="/ppd/">{{ $t('ppd-title') }}</a></li>
								<li class="breadcrumb-item active" aria-current="page">{{ $t('title') }}</li>
							</ol>
						</nav>
					</div>

					<h1 class="mb-4">{{ $t("title") }}</h1>

					<Navigation></Navigation>

					<div class="tab-content my-4" id="myTabContent">
						<router-view/>
					</div>
					<p>{{ $t('disclaimer') }}</p>
				</div>
			</main>
		</div>
	</div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
	name: 'app',
	components: {
		Navigation,
	}
}
</script>

<style>
</style>
